export enum Routes {
  Home = '/',
  ApplicationSuites = 'application-suites',
  ApplicationSuite = 'application-suites/:suiteId',
  Tenants = 'tenants',
  Tenant = 'application-suites/:suiteId/tenants/:tenantId',
  UserGroups = 'user-groups',
  UserGroup = 'application-suites/:suiteId/tenants/:tenantId/user-groups/:usergroupId',
  Roles = 'roles',
  Role = 'application-suites/:suiteId/tenants/:tenantId/roles/:roleId',
  Claim = 'application-suites/:suiteId/tenants/:tenantId/claims/:claimId',
  Claims = 'claims',
  Acls = 'acls',
  AclResources = 'resources',
  AclAccesses = 'accesses',
  ApiKeys = 'apikeys',
  AuthorizedIssuers = 'authorized-issuers',
  Licenses = 'licenses',
  License = 'application-suites/:suiteId/tenants/:tenantId/licenses/:licenseId',
  Users = 'users',
  User = 'application-suites/:suiteId/tenants/:tenantId/users/:userId',
  Reports = 'reports',
  UserGroupsReport = 'reports/user-groups-proof-of-delivery',
  UserGroupACLsReport = 'reports/user-group-acls',
  LicensesReport = 'reports/licenses-proof-of-delivery',
  UsersWithNewAccessReport = 'reports/new-users-access',
  AclResourceUserListReport = 'reports/acl-resource-user-list',
  Monitoring = 'monitoring',
  GlobalRoles = 'global-roles',
  Help = 'help',
  AclEntries = 'acl-entries',
  UsersDetails = 'users/:userId',
  Admin = 'admin',
  AccountLinkingDashboard = 'admin/account-linking-dashboard',
  Imports = 'admin/imports',
  ProductPackages = 'packages',
  ProductPackage = 'application-suites/:suiteId/tenants/:tenantId/packages/:productPackageId',
  Rals = 'rals',
}

export const RoutesNameMap = new Map<string, string>([
    [ Routes.ApplicationSuites, 'Application Suites' ],
    [ Routes.ApplicationSuite, 'Application Suite Details' ],
    [ Routes.Tenants, 'Tenants' ],
    [ Routes.Tenant, 'Tenant Details' ],
    [ Routes.ApiKeys, 'API Keys' ],
    [ Routes.Licenses, 'Licenses' ],
    [ Routes.License, 'License Details' ],
    [ Routes.Users, 'Users' ],
    [ Routes.User, 'User Membership'],
    [ Routes.Reports, 'Reports' ],
    [ Routes.Monitoring, 'Monitoring' ],
    [ Routes.GlobalRoles, 'Global Roles' ],
    [ Routes.Help, 'Help' ],
    [ Routes.UserGroups, 'User Groups' ],
    [ Routes.UserGroup, 'User Group Details' ],
    [ Routes.Roles, 'Roles' ],
    [ Routes.Role, 'Role Details' ],
    [ Routes.Claims, 'Claims' ],
    [ Routes.Claim, 'Claim Details' ],
    [ Routes.Acls, 'ACLs' ],
    [ Routes.AclResources, 'ACL Resources' ],
    [ Routes.AclAccesses, 'ACL Accesses' ],
    [ Routes.AuthorizedIssuers, 'Authorized Issuers' ],
    [ Routes.AclEntries, 'ACL Entries' ],
    [ Routes.UsersDetails, 'User Profile' ],
    [ Routes.Admin, 'Admin' ],
    [ Routes.AccountLinkingDashboard, 'DJ IdP Account Linking Failures' ],
    [ Routes.Imports, 'Imports'],
    [ Routes.ProductPackages, 'Product Packages'],
    [ Routes.ProductPackage, 'Product Package Details'],
    [ Routes.Rals, 'ACLs'],
]);
